import type { ComponentProps } from 'react';
import { cx } from '@/styled-system/css';
import { skeletonBlock } from './skeletonBlock.styles';

type SkeletonBlockProps = ComponentProps<'span'> & {
  /** Corner rounding; use `md` to sit flush with card surfaces. */
  radius?: 'sm' | 'md';
  /** Sit inside a line of text instead of on its own line. */
  inline?: boolean;
};

export function SkeletonBlock({ className, radius, inline, ...props }: SkeletonBlockProps) {
  return <span {...props} aria-hidden="true" className={cx(skeletonBlock({ radius, inline }), className)} />;
}
